import classNames from 'classnames';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { _ } from '/@/locale';
import ProductRow from '../product-row';
import styles from './styles.module.css';

@autobind
export default class CornPhenologyChart extends Component {
    static propTypes = {
        products: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.number.isRequired,
                name: PropTypes.string.isRequired,
                phenology: PropTypes.arrayOf(PropTypes.string),
                gdus: PropTypes.shape({
                    emergence: PropTypes.number,
                    flowering: PropTypes.number,
                    maturity: PropTypes.number,
                }),
            })
        ).isRequired,
    };

    render() {
        const products = this.props.products.sort((a, b) => {
            if (a.phenology && b.phenology) return 0;
            if (!a.phenology && b.phenology) return 1;
            return -1;
        });

        return (
            <div className={styles.root}>
                <div className={styles.stages}>
                    <div className={styles.stage1}>
                        <div className={classNames(styles.image, styles.planting)} />
                        <div className={styles.label}>{_('Siembra')}</div>
                    </div>
                    <div className={styles.stage2}>
                        <div className={classNames(styles.image, styles.emergence)} />
                        <div className={styles.label}>{_('Emergencia')}</div>
                    </div>
                    <div className={styles.stage3}>
                        <div className={classNames(styles.image, styles.flowering)} />
                        <div className={styles.label}>{_('Floración')}</div>
                    </div>
                    <div className={styles.stage4}>
                        <div className={classNames(styles.image, styles.maturity)} />
                        <div className={styles.label}>{_('Madurez Fisiológica')}</div>
                    </div>
                </div>
                <div className={styles.transitions}>
                    <div className={styles.transition1} />
                    <div className={styles.transition2} />
                    <div className={styles.transition3} />
                </div>
                <div className={styles.container}>
                    <div className={styles.references}>
                        <div className={styles.stageReference1} />
                        <div className={styles.stageReference2} />
                        <div className={styles.stageReference3}>
                            <div className={classNames(styles.criticalReference, styles.overlap)}>
                                <div className={styles.criticalLabel}>{_('Período crítico: +/- 15 días')}</div>
                            </div>
                        </div>
                        <div className={styles.stageReference4} />
                    </div>
                    <div className={styles.products}>
                        {products.map((product) => (
                            <ProductRow
                                key={product.id}
                                name={product.name}
                                phenology={product.phenology}
                                gdus={[product.gdus.emergence, product.gdus.flowering, product.gdus.maturity]}
                                renderName={true}
                                styles={styles}
                            />
                        ))}
                    </div>
                </div>
            </div>
        );
    }
}
